export const applyHiddenAnimation = () => {
  const hiddenElements = document.querySelectorAll(".hidden");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
      } else {
        // entry.target.classList.remove("show");
      }
    });
  });
  hiddenElements.forEach((element) => {
    observer.observe(element);
  });

  return () => {
    hiddenElements.forEach((element) => {
      observer.unobserve(element);
    });
    observer.disconnect();
  };
};
